//*** -- Keep `require` and `module.exports` over `import` for Santa Worker (Felix) -- ***

// `require` is needed for ooi Worker
// eslint-disable-next-line
const {createViewerScript} = require('./createViewerScript');

module.exports = createViewerScript;
